<template>
  <div class="site-list">
    <div class="item" v-for="(item) in siteList" :key="item.siteId" @click="goToClient(item)">
      <!-- 测试站点水印 -->
      <img v-if="item.ifTestSite" src="@/assets/img/demo_site.svg" class="demo-site-watermark" />
      <!-- 置顶操作按钮 -->
      <div class="set-icon">
        <img :src="!item.ifPin ? notPinIcon : pinedIcon" class="pin-normal" @click.stop="updatePinStatus(item)" />
        <img :src="!item.ifPin ? notPinIconHover : pinedIconHover" class="pin-hover" @click.stop="updatePinStatus(item)" />
      </div>
      <div class="siteItem">
        <div class="first-word">
          {{ item.clientName[0] }}
        </div>
        <div class="info">
          <p class="c-name" :title="item.clientName">{{ item.clientName }}</p>
          <p class="s-name" :title="item.siteName">{{ item.siteName }}</p>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import API from '@/api'
import { mapGetters } from 'vuex'
import { loading } from '@/utils'

import SvgIcon from "@/components/svgIcon/index";

export default {
  name: 'AsideLeft',
  components: { SvgIcon },
  data() {
    return {
      user: {},
      notPinIcon: require(`@/assets/img/icon-pin.svg`),
      pinedIcon: require(`@/assets/img/icon-pin-fill.svg`),
      notPinIconHover: require(`@/assets/img/icon-pin-hover.svg`),
      pinedIconHover: require(`@/assets/img/icon-pin-fill-hover.svg`),
      siteList: [],
    }
  },
  props: {
    siteIds: {
      type: String,
      default: ''
    }
  },
  watch: {
    siteIds() {
      this.getSite()
    }
  },
  computed: {
    ...mapGetters('common', {
      getUser: 'getUser'
    }),
  },
  mounted() {
    this.user = { ...this.getUser }
  },
  methods: {
    getSite() {
      const _loading = loading()
      _loading.load()
      const params = {
        siteIds: this.siteIds,
        pageNum: 1,
        pageSize: 999
      }
      try {
        API.businessHome.querySite(params).then((res) => {
          if (res.code === '1') {
            this.siteList = res.data.records || []
          } else {
            this.$message.error(this.$t(res.code))
          }
        })
      } catch (e) { } finally {
        _loading.close()
      }
    },
    async updatePinStatus(item) {
      const { code } = await API.businessHome.updatePinStatus({
        "siteId": item.siteId,
        "userId": this.getUser.userId,
        "ifPin": !item.ifPin
      })
      if (code === '1') {
        item.ifPin = !item.ifPin
        this.getSite()
      }
    },
    async goToClient(data) {
      sessionStorage.setItem('siteClassification', data.siteClassification)
      if (data.invalidIpFlag) {
        this.$message({
          dangerouslyUseHTMLString: true,
          message: this.$t('USER_IP_NOTAVALIABLE_2'),
          type: 'error'
        })
        return
      }
      await this.queryMenuList(data.siteId)
      this.$store.commit('common/setSite', data)
      API.businessHome.siteClick({
        "siteId": data.siteId,
        "userId": this.getUser.userId
      })
      this.$router.push({
        path: '/client',
        query: data
      })
    },
    async queryMenuList(siteId) {
      this.getUserSiteAuthorityInfo(siteId)
    },
    // 获取用户载当前站点的权限
    getUserSiteAuthorityInfo(siteId) {
      API.common.getClientAuthorityInfo({ siteId }).then((res) => {
        if (res.code === '1') {
          this.$store.commit('common/setUserIdentity', res.data)
        } else {
          this.$message.error(this.$t(res.code))
        }
      })
    },
  }
}
</script>

<style scoped>
.site-list {
  width: 100%;
  height: 100%;
  padding: 0 12PX;
  overflow-y: auto;
}

.site-list::-webkit-scrollbar {
  width: 8PX !important;
  /*高宽分别对应横竖滚动条的尺寸*/
  height: 8PX !important;
}

.site-list .item {
  background-color: #1e49e210;
  border-radius: 5px;
  position: relative;
  padding: 12PX;
  cursor: pointer;
  margin-bottom: 10PX;
}
.site-list .item:last-child {
  margin-bottom: 0;
}

.siteItem {
  display: flex;
  align-items: center;
}

.first-word {
  width: 30PX;
  height: 30PX;
  border-radius: 3px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #fff;
  background-color: #1e49e2;
  margin-right: 10PX;
  flex-shrink: 0;
  font-weight: 600;
}

.info {
  color: #1e49e2;
  width: calc(100% - 40PX);
}

.info .c-name {
  font-size: 16PX;
  font-weight: 600;
  width: 100%;
  margin-bottom: 5px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  vertical-align: middle;
}

.info .s-name {
  font-size: 12PX;
  width: calc(100% - 15PX);
  display: inline-block;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  vertical-align: middle;
}

.demo-site-watermark {
  height: 70%;
  position: absolute;
  bottom: 15%;
  right: 5%;
}

.set-icon {
  position: absolute;
  bottom: 5PX;
  right: 10PX;
}

.pin-hover {
  display: none;
  cursor: pointer;
}

.pin-normal {
  display: block;
  cursor: pointer;
}

.site-list .item:hover .pin-hover {
  display: block;
}

.site-list .item:hover .pin-normal {
  display: none;
}

.site-list .item:hover {
  background: url(~@/assets/img/bg_site-hover.png) no-repeat;
  background-size: cover;
}

.site-list .item:hover {
  background: url(~@/assets/img/bg_site-hover.png) no-repeat;
  background-size: cover;
}

.site-list .item:hover .first-word {
  background-color: #fff;
  color: #1e49e2;
}

.site-list .item:hover .info {
  color: #fff;
}
</style>